/** @jsxRuntime automatic */
/** @jsxImportSource @fluentui/react-jsx-runtime */

import * as React from 'react';

import {
  generateReferenceCitationPreview,
  type ReferenceCitationPreviewGenerator,
  type ReferenceCitationPreviewGeneratorProps,
} from './generateReferenceCitationPreview';

export type UseReferenceCitationPreviewProps = ReferenceCitationPreviewGeneratorProps;

export type UseReferenceCitationPreview = ReferenceCitationPreviewGenerator;

/**
 * Hook to generate a Citation - Reference pair with correctly wired props.
 * Both the Citation and the Reference act as trigger components to Previews that are also correctly wired by the hook.
 * Props can either be passed in to the hook or applied directly to the generated components in JSX.
 *
 * This hook internally calls the `generateReferenceCitationPreview` function and memoizes its return value based on the props.
 * You should only use this hook when the props used to generate the Citation - Reference pair can change dynamically.
 * If they are static, or in case you wanted to generate multiple pairs within a cycle, you should call
 * `generateReferenceCitationPreview` directly.
 *
 * @returns A Citation - Reference pair with correctly wired props.
 */
export const useReferenceCitationPreview: UseReferenceCitationPreview = props => {
  return React.useMemo(() => generateReferenceCitationPreview(props), [props]);
};
